/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../../Stages/StagesCase";
import personFields from "../modules/personFields";
import { FormDefinition } from "../../../../types/ProductService/ProductService";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { BackofficeUser } from "../../../../types/BackofficeUser";
import { PendingCase } from "../../../../types/Products/PendingCase";

export function stageFormDefinition(
  product: PendingCase,
  currentUser?: BackofficeUser
): ReturnType<FormDefinition<PendingCase>> {
  const createdFields: FormElementPropsWithoutProduct<PendingCase>[] = [
    ...personFields({ path: `${product.productClassName}.client` }),
  ];

  const completedFields: FormElementPropsWithoutProduct<PendingCase>[] = [];

  return {
    [stagesCase.STAGE_CREATED]: createdFields,
    [stagesCase.STAGE_COMPLETED]: completedFields,
  };
}
